import axios from 'axios'
import buildURL from 'axios/lib/helpers/buildURL.js'

import factory from './lib/factory'

/* factory have default validate status, so disable axios here */
axios.defaults.validateStatus = undefined

const http = factory(axios.request.bind(axios))

// 得到包括query参数的完整url
http.getUri = axios.getUri

http.buildURL = buildURL

const {
  get,
  del,
  head,
  post,
  put,
  patch,
  getUri,
  makeUri,
  interceptors,
  configure,
} = http

export default http
export {
  get,
  del,
  head,
  post,
  put,
  patch,

  getUri,
  makeUri,
  interceptors, /* it is http interceptors, not axios`s interceptors */
  configure,
  buildURL,
  axios,
}
